
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { iChannelDetails, iChannelSearch, iTimeParams } from '@/interface/exchange-code';
import { eExtensionLaunch } from '@/interface/eCommand';
import { iSelectValueString } from '@/interface/cancel-detail';
import { getChannelList, addChannelData, editChannelData } from '@/api/exchange-code';
import moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import ChannelSummary from './channel-summary.vue';
import ChannelDetails from './channel-details.vue';
Vue.use(VueClipboard);
@Component({
  filters: {
    time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD');
    },
  },
  components: { ChannelSummary, ChannelDetails },
})
export default class ChannelExtension extends Vue {
  @Prop() timeInfo!: iTimeParams;
  detailsTable: iChannelDetails[] = [];
  total: number = 0;
  searchInfo: iChannelSearch = {
    start: 0,
    end: 0,
    channel_name: '',
    opt_user: '',
    channel_type: '',
    page: 1,
    page_size: 10,
  };
  loading: boolean = false;
  dialogVisible: boolean = false;
  is_show_msg: string = '';
  add_channel_name: string = '';
  channel_title: string = '';
  channel_code: string = '';
  add_channel_number: number = 0;
  channelType: iSelectValueString[] = [
    {
      label: '全部渠道类别',
      value: '',
    },
    {
      label: '官网(' + eExtensionLaunch.WEBSITE + ')',
      value: eExtensionLaunch.WEBSITE,
    },
    {
      label: '用户分享(' + eExtensionLaunch.USERSHARE + ')',
      value: eExtensionLaunch.USERSHARE,
    },
    {
      label: '渠道投放(' + eExtensionLaunch.CHANNELLAUNCH + ')',
      value: eExtensionLaunch.CHANNELLAUNCH,
    },
    {
      label: '云更新菜单(' + eExtensionLaunch.ClOUDMUEN + ')',
      value: eExtensionLaunch.ClOUDMUEN,
    },
  ];
  @Watch('timeInfo', { deep: true })
  timeInfo_Watch() {
    this.searchInfo.start = this.timeInfo.start;
    this.searchInfo.end = this.timeInfo.end;
    this.getList();
  }
  searchList() {
    this.searchInfo.page = 1;
    this.getList();
  }
  addChannel() {
    this.channel_title = '新建推广';
    this.add_channel_name = '';
    this.channel_code = '';
    this.is_show_msg = '';
    this.add_channel_number = 0;
    this.dialogVisible = true;
  }
  copyLink(row: iChannelDetails) {
    if (!row.link) {
      this.$message.error('复制失败');
      return;
    }
    this.$copyText(row.link)
      .then(res => {
        this.$message.success('复制成功');
      })
      .catch(err => {
        this.$message.error('复制失败');
      });
  }
  editRow(row: iChannelDetails) {
    this.channel_title = '编辑推广';
    this.add_channel_name = row.name;
    this.add_channel_number = row.coin;
    this.channel_code = row.code;
    this.dialogVisible = true;
  }
  disableHandle(row: iChannelDetails) {
    this.$msgbox({
      title: '请确认是否要禁用当前渠道链接？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          //
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {});
  }
  handleSizeChange(size: number) {
    this.searchInfo.page = 1;
    this.searchInfo.page_size = size;
    this.getList();
  }
  handleCurrentChange(page: number) {
    this.searchInfo.page = page;
    this.getList();
  }
  sureChannel() {
    if (this.add_channel_name) {
      if (this.add_channel_number < 0 || isNaN(this.add_channel_number)) {
        this.is_show_msg = '云币数量输入错误';
        return;
      }
      if (!this.add_channel_number) {
        this.add_channel_number = 0;
      }
      this.is_show_msg = '';
      // 新增
      if (!this.channel_code) {
        this.addSaveChannel();
      } else {
        this.editSaveChannel();
      }
      // this.addSaveChannel();
    }
  }
  async getList() {
    this.loading = true;
    try {
      const res = await getChannelList(this.searchInfo);
      if (res && res.code == 0) {
        this.detailsTable = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
  async addSaveChannel() {
    this.loading = true;
    try {
      const res = await addChannelData({ name: this.add_channel_name, coin: this.add_channel_number });
      if (res && res.code == 0) {
        //
        this.$message.success('保存成功');
        this.dialogVisible = false;
        this.getList();
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
  async editSaveChannel() {
    this.loading = true;
    try {
      const res = await editChannelData({ name: this.add_channel_name, coin: this.add_channel_number, code: this.channel_code });
      if (res && res.code == 0) {
        //
        this.$message.success('编辑成功');
        this.dialogVisible = false;
        this.getList();
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
  mounted() {
    this.getList();
  }
}
